import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { getLocaleMonthNames, FormStyle, TranslationWidth } from '@angular/common';

import { IDateParser } from './IDateParser';
import { IDateParserOptions } from './IDateParserOptions';


@Injectable()
export class ShortDateParserService implements IDateParser {
    private monthsByCode: Map<string, number> = new Map();
    private detector: RegExp = /^\s*([0-9]+)\s*([^0-9]+)\s*([0-9]+)?\s*$/;

    constructor (
        @Inject(LOCALE_ID) locale: string
    ){
        this.addMonths(getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Wide) as string[]);
        this.addMonths(getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Abbreviated) as string[]);
        this.addMonths(getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Short) as string[]);
        this.addMonths(getLocaleMonthNames(locale, FormStyle.Format, TranslationWidth.Narrow) as string[]);
    }

    public parse(text: string, options: IDateParserOptions = {}): Date{
        const parsed: RegExpExecArray = this.detector.exec(text);

        if (!parsed){
            return null;
        }

        const day: number = +parsed[1];
        const month: number = this.getMonth(parsed[2]);

        if (!isValidDay(day) || !month){
            return null;
        }

        const year: number = getYear(parsed[3], day, month, options);

        return new Date(year, month, day);
    }

    private addMonths(names: string[]): void{
        names.forEach((name: string, index: number): void => {
            this.monthsByCode.set(normalize(name), index);
        });
    }

    private getMonth(text: string): number{
        return this.monthsByCode.get(normalize(text));
    }
}

function normalize(text: string): string{
    return text && text.toLocaleLowerCase()
        .replace(/\.$/, '')
        .replace(/[éèê]/g, 'e')
        .replace(/[û]/g, 'u');
}

function isValidDay(day: number): boolean{
    return !isNaN(day) && day > 0 && day <= 31 && Math.round(day) === day;
}

function getYear(shortYear: string, day: number, month: number, options: IDateParserOptions): number{
    const currentYear: number = new Date().getFullYear();
    const year: number = shortYear === undefined? currentYear : +shortYear;

    if (isNaN(year)){
        return null;
    }

    if (year < 100){
        const currentCenturyYear: Date = new Date(year + 2000, month, day);

        if (options.max && currentCenturyYear > options.max){
            return year + 1900;
        }

        return year + 2000;
    }

    return year;
}

